module.exports = __webpack_public_path__ + "static/media/29090029-AYF0wSgs.035b7b9c.JPG";